export default __webpack_public_path__ + "static/media/icon-s-fork.f88042ea.svg";